import { ReactNode, useEffect } from 'react'
import { Box, Icon, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useDrawerContext } from '../contexts';

interface ILayoutBaseDePaginaProps {
    titulo: string;
    barraDeFerramentas: ReactNode;
    children?: ReactNode;
}
export const LayoutBaseDePagina: React.FC<ILayoutBaseDePaginaProps> = ({ titulo, barraDeFerramentas, children }) => {
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));

    const { toggleDrawerOpen } = useDrawerContext();

    useEffect(() => {
        document.title = titulo == "" ? "Zdoc - Login" : "Zdoc - " + titulo;
    }, [titulo]);
    const currentYear = new Date().getFullYear();

    return (
        <Box height="100%" display="flex" flexDirection="column" gap={1}>
            <Box padding={1} display="flex" alignItems="center" height={theme.spacing(smDown ? 6 : mdDown ? 6 : 8)}>
                {mdDown && //Botão so aparecer em telas pequenas 
                    (<IconButton onClick={toggleDrawerOpen}>
                        <Icon>menu</Icon>
                    </IconButton>)}

                <Typography
                    whiteSpace="nowrap"// faz com que o texto não quebre a linha no caso de titulos muito grandes
                    overflow="hidden"// faz com que o texto não ultrapasse a box e quebre os elementos depois dele
                    textOverflow="ellipsis"// adciona ... no final do texto caso ele ultrapasse o box (no caso de telas pequenas) 
                    variant={smDown ? 'h5' : mdDown ? 'h4' : 'h3'}// muda o tamanho do texto dependendo do tamanho da tela
                    textTransform={'capitalize'}
                >
                    {titulo}
                </Typography>
            </Box>

            {barraDeFerramentas && //Barra de ferramentas so irá aparecer quando tiver algum elemento dentro
                (<Box>
                    {barraDeFerramentas}
                </Box>)}

            <Box flex={1} overflow="auto">{/* overflow faz com que somente os elementos filhos rolem na tela */}
                {children}
            </Box>

            <Box display="flex" justifyContent="center" paddingY={1} bgcolor={theme.palette.background.paper}>
                <Typography> Copyright @{currentYear} | Zdoc - Todos os direitos reservados. </Typography>
            </Box>
        </Box>
    );
}